import { render, staticRenderFns } from "./CommonDetail.vue?vue&type=template&id=4b940f5e&"
import script from "./CommonDetail.vue?vue&type=script&lang=js&"
export * from "./CommonDetail.vue?vue&type=script&lang=js&"
import style0 from "./CommonDetail.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports